import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

const OuterContainer = styled.div`
    overflow: hidden;
`;

const InnerContainer = styled.div`
    position: relative;
    padding: 0.8em 0.8em;
    border-radius: 0 0.6em 0.6em 0.6em;
    background: #0001;
`;

const Title = styled.span<{ color?: string }>`
    display: inline-block;
    padding: 0.18em 0.8em;
    font-weight: bold;
    background: ${(props) => props.color ?? "#ec454fee"};
    color: white;
    border-radius: 0.6em 0.6em 0 0;
    min-width: 200px;
`;

const Icon = styled(FontAwesomeIcon)`
    opacity: 0.7;
    transform: scale(0.9);
`;

export type GroupContainerProps = {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
    title?: React.ReactNode;
    icon?: IconDefinition;
    color?: string;
};

export function GroupContainer(props: GroupContainerProps) {
    return (
        <OuterContainer style={props.style} className={props.className}>
            {props.title && (
                <Title color={props.color}>
                    {props.icon && <Icon icon={props.icon} />} {props.title}
                </Title>
            )}
            <InnerContainer>{props.children}</InnerContainer>
        </OuterContainer>
    );
}
